module.exports = __webpack_public_path__ + "src/app/_content/imgs/endOfTerm/vid_static.jpg?3f4b0c8abc900a2098b9c2b3b186734a";